import { STAGES } from './enums.js';
/**
 * The two things observed about a fund at a stage (`fund_observation.attribute`).
 * Leading a round is being in it, so a fund that leads at a stage invests there.
 */
export const STAGE_ATTRIBUTES = ['stage_invests', 'stage_leads'];
export function isStageAttribute(value) {
    return value === 'stage_invests' || value === 'stage_leads';
}
/** Where an observation came from, in the order a hover reads them. */
export const OBSERVATION_SOURCES = [
    'person',
    'rounds',
    'dealroom',
    'classifier',
    'linkedin',
    'sheet',
];
/** Leading a round is being in it, so ticking Leads ticks Invests. */
export function normaliseStageChoice(choice) {
    return { ...choice, participates: choice.participates || choice.leads };
}
/** The stages a fund invests at, in stage order. */
export function stagesInvesting(fund) {
    return STAGES.filter((stage) => fund.stages.some((entry) => entry.stage === stage && entry.participates));
}
/** The stages a fund leads at, in stage order. */
export function stagesLeading(fund) {
    return STAGES.filter((stage) => fund.stages.some((entry) => entry.stage === stage && entry.leads));
}
/** Every stage, in order, as the picker shows it: unset stages are two empty boxes. */
export function stageChoicesOf(fund) {
    return STAGES.map((stage) => {
        const entry = fund.stages.find((candidate) => candidate.stage === stage);
        return {
            stage,
            participates: entry?.participates ?? false,
            leads: entry?.leads ?? false,
        };
    });
}
/** True when only the rounds vouch for it: nobody claimed it, so the chip is hollow. */
export function onlyObserved(entry) {
    const asserting = entry.sources.filter((fact) => fact.invests === 'asserts' || fact.leads === 'asserts');
    return asserting.length > 0 && asserting.every((fact) => fact.source === 'rounds');
}
/** "does not lead at Series A": a person's answer, as a hover repeats it. */
export function saidPhrase(conflict, stageLabel) {
    const verb = conflict.attribute === 'stage_leads' ? 'lead' : 'invest';
    return conflict.said === 'asserts'
        ? `${verb}s at ${stageLabel}`
        : `does not ${verb} at ${stageLabel}`;
}
//# sourceMappingURL=fundStages.js.map